module.exports = __webpack_public_path__ + "img/desktop.1775439203884.jpg";